<template>
  <span class="text-center">
    <span v-if="isTotalWinnings || isPendingWinnings" class="block caption-bold">
      {{ winningMessage }}
    </span>
    <span v-if="show === 'onlyPrize'" :class="sizes.headline">
      {{ formattedMoney }}
    </span>
    <span v-else-if="show === 'onlyFreeTicket'" :class="['flex flex-col', sizes.headline]">
      <ScratchcardFreeTicketTranslation
        v-bind="{ freeTickets }"
        :ticket-class="sizes.subline"
        type="free-ticket-only"
      />
    </span>
    <span v-else :class="['flex flex-col', sizes.headline]">
      <span>
        {{ formattedMoney }}
      </span>
      <ScratchcardFreeTicketTranslation
        v-bind="{ freeTickets }"
        :ticket-class="sizes.subline"
        type="with-prize"
      />
    </span>
  </span>
</template>

<script lang="ts" setup>
const { t: $t } = useI18n()

import type { Money } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Props = {
  freeTickets?: number
  isPendingWinnings?: boolean
  isTotalWinnings?: boolean
  type?: 'normal' | 'small'
  win?: Money
}

const {
  freeTickets = 0,
  isPendingWinnings,
  isTotalWinnings,
  type = 'normal',
  win = { currency: 'USD', value: 0 },
} = defineProps<Props>()

const show = computed(() => {
  if (win.value > 0 && freeTickets <= 0) return 'onlyPrize'
  if (win.value <= 0 && freeTickets > 0) return 'onlyFreeTicket'
  return 'prizeAndFreeTicket'
})

const sizes = computed(() => ({
  headline: type === 'small' ? 'headline-h4-headline' : 'headline-h2-headline',
  subline: type === 'small' ? 'caption-bold' : 'headline-h4-headline',
}))

const formattedMoney = computed(() => {
  if (!win) return

  const fractions = win.value.toString().length >= 9 ? 0 : 2
  return formatMoney(win, { fractionDigits: fractions })
})

const winningMessage = computed(() => {
  if (isPendingWinnings) return $t('winninganimation.text.pendingwinnings')
  if (isTotalWinnings) return $t('winninganimation.text.totalwinnings')
  return ''
})
</script>
